$(function () {

  var init = function () {
    // color picker
    $('#room_type_color, #room_group_color').spectrum({
      allowEmpty: true, 
      preferredFormat: 'rgb', 
      cancelText: I18n.t('cancel'), 
      chooseText: I18n.t('save'), 
      showButtons: true, 
      showInput: true, 
      color: $('#event_color').val(),
      showPalette: true,
      palette: [
        ["#600","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"],
        ["#900","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
        ["#c00","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
        ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
        ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
        ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"]
      ]
    }); 

    // sortable
    var $sortable = $('#images-sortable');
    $sortable.sortable({
      axis: 'y',
      handle: '.label',
      update: function () {
        $sortable.find('.sortable-image').each(function (index) {
          $(this).find('.position').val(index);
        });
      }
    });
    $sortable.sortable('refresh');

    function buildImageSortable($images) {
      $images.each(function () {
        var $this = $(this);

        if ($sortable.find('.sortable-image[data-id=' + $this.data('id') + ']').length > 0) {
          return true; //don't append since we already have this image
        }

        $sortable.append($('<div class="sortable-image" data-id="' + $this.data('id') + '">' +
                           '<div class="label"><span class="handle">&#9776;</span><img src="' + $this.attr('src') + '" /></div>' + 
                           '<input type="hidden" name="accommodation_images_image_id[]" value="' + $this.data('id') + '" />' + 
                           '<input type="hidden" name="accommodation_images_' + $this.data('id') + '_position" class="position" value="" />' + 
                           '<button data-id="' + $this.data('id') + '" class="remove-image pull-right btn btn-secondary btn-sm">' + I18n.t('remove') + '</button></div>'))
      });
      $sortable.sortable('refresh');
    };

    window._insertImages = function (images) {
      var $images = $(images);
      buildImageSortable($images);
    };

    $(document.body).on('click', '.remove-image', function () {
      $sortable.find('.sortable-image[data-id=' + $(this).data('id') + ']').remove();
      return false;
    });
  };
  init();

  // var super_refresh_data_table = window.refresh_data_table;
  // window.refresh_data_table = function () {
  //   //super_refresh_data_table(init);
  // }  

  // var super_refresh_relations = window.refresh_relations;
  // window.refresh_relations = function () {
  //   super_refresh_relations(init);    
  // };

});